import { CharacterStyleCandidate } from '../types';

const API_BASE = process.env.REACT_APP_API_BASE || '/api';

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, { ...init, headers: { ...authHeaders(), ...init?.headers } });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed: ${res.status}`);
  }
  return res.json();
}

function characterQuery(characterName: string): string {
  return new URLSearchParams({ characterName }).toString();
}

export interface StateStylingSearchResponse {
  candidates: CharacterStyleCandidate[];
  hasMore: boolean;
  tagsFlat?: string[];
  tagsStatus?: string;
  stylingId?: string;
}

export const stateStylingSearch = (
  projectId: string,
  characterName: string,
  state: string,
): Promise<StateStylingSearchResponse> =>
  request(`/projects/${projectId}/state-styling-search?${characterQuery(characterName)}`, {
    method: 'POST',
    body: JSON.stringify({ state }),
  });

export const stateStylingSearchMore = (
  projectId: string,
  characterName: string,
  state: string,
  page: number,
): Promise<StateStylingSearchResponse> =>
  request(`/projects/${projectId}/state-styling-search/more?${characterQuery(characterName)}`, {
    method: 'POST',
    body: JSON.stringify({ state, page }),
  });

export const stateStylingSearchSelect = (
  projectId: string,
  characterName: string,
  state: string,
  imageUrls: string[],
): Promise<{ refImageUrls: string[] }> =>
  request(`/projects/${projectId}/state-styling-search/select?${characterQuery(characterName)}`, {
    method: 'POST',
    body: JSON.stringify({ state, imageUrls }),
  });
